import { firebaseauth } from './index';
import chatFirebaseToken from '../api/graphql/mutations/chatFirebaseToken';
import { needsFirebaseSignIn } from '../utils/onlinePresence';

/* The CMS logs in against our own GraphQL API, not against Firebase, so nothing
 * in the admin holds a Firebase session by itself. Anything that talks to
 * Firebase (the online-users presence, the Primavera World stream chat) has to
 * exchange the admin token for a Firebase custom token first, via the
 * `chatToken` mutation.
 *
 * There is only one Firebase session per tab, and the custom token carries
 * claims minted for one post (chat moderator ids), so the sign-in is shared and
 * memoized per post: two callers mounting at the same time get the same
 * session instead of racing two signInWithCustomToken calls, and the last one
 * to resolve can no longer strip the other's claims. */

let signedInSlugName;
let pendingSlugName;
let pendingSignIn = null;

const ensureFirebaseAuth = (slugName) => {
  const currentUid = firebaseauth.currentUser && firebaseauth.currentUser.uid;

  if (!needsFirebaseSignIn({ currentUid, signedInSlugName, slugName })) {
    return Promise.resolve(firebaseauth.currentUser);
  }

  if (pendingSignIn && pendingSlugName === slugName) return pendingSignIn;

  pendingSlugName = slugName;
  pendingSignIn = chatFirebaseToken({ channels: [], postSlugName: slugName })
    .then((token) => {
      if (!token) {
        console.log('ensureFirebaseAuth: chatFirebaseToken returned no token');
        return null;
      }
      return firebaseauth.signInWithCustomToken(token)
        .then(({ user }) => {
          signedInSlugName = slugName;
          return user;
        });
    })
    .catch((err) => {
      console.log('ensureFirebaseAuth: Firebase sign in failed', err);
      return null;
    })
    .then((user) => {
      pendingSignIn = null;
      pendingSlugName = undefined;
      return user;
    });

  return pendingSignIn;
};

export default ensureFirebaseAuth;
